import { FormControl } from "@primer/react";
import "./Field.css";

export function Field({ children, error = "", help = "", label }) {
  return (
    <FormControl className={`field${error ? " invalid" : ""}`}>
      <FormControl.Label>{label}</FormControl.Label>
      {children}
      {help ? <FormControl.Caption>{help}</FormControl.Caption> : null}
      {error ? <FormControl.Validation variant="error">{error}</FormControl.Validation> : null}
    </FormControl>
  );
}
